module.exports = __webpack_public_path__ + "img/college_event.5df0e810.jpg";